export enum DraftConvEnum {
    CreateConv = "CreateConv",
    EditTitle = "EditTitle",
    AddParticipant = "AddParticipant",
    RemoveParticipant = "RemoveParticipant",
    DeleteConv = "DeleteConv"
}
